import * as api from "@/api";
import makeListingMixin from "@lab/store/vuexListingMixin";
import { debounce, forEach, filter } from "lodash";
import format from "date-fns/format";
import FileSaver from "file-saver";
import { VacancyTypeDebounce } from "@lab/types/listings";
import { putVacancyType } from "@lab/api/vacancy.types.api";

export default makeListingMixin(
	"vacancytype",
	api.vacancytypes
)({
	state: {
		vacancyEditorID: 0
	},
	mutations: {
		updateAvailability(state, { id, count }) {
			state.byID[id].available = count;
			const today = new Date();
			state.byID[id].updated = today.toJSON();
		},
		updateExpected(state, { id, count }) {
			state.byID[id].expected = count;
			const today = new Date();
			state.byID[id].updated = today.toJSON();
		},
		vacancytypesUpdatedDate(state, listingid) {
			const vacancies = filter(state.byID, { listingid }).map(
				(vacancy) => vacancy.id
			);
			forEach(vacancies, (id) => {
				const today = new Date();
				state.byID[id].updated = today.toJSON();
			});
		},
		updateVacancyEditor(state, { listingID }) {
			state.vacancyEditorID = listingID;
		}
	},
	actions: {
		async userVacancyTypesLoad(context, search) {
			context.commit(`vacancytypesLoadStart`);
			try {
				const things = await api.userVacancytypes(null, null, search);
				context.commit(`vacancytypesLoadSuccess`, things, search);
			} catch (error) {
				context.commit(`vacancytypesLoadFailure`, error.message);
				throw error;
			}
		},
		updateVacancyEditorID(context, payload) {
			const { listingID } = payload;
			context.commit("updateVacancyEditor", {
				listingID
			});
		},
		updateAvailability(context, payload) {
			const { id, count, successFn } = payload;
			context.commit("updateAvailability", {
				id,
				count
			});
			const availabilty = context.getters.vacancytypeGet(id);
			context.dispatch("vacancytypeUpdateDebounce", {
				availabilty,
				successFn
			});
		},
		updateExpected(context, payload) {
			const { id, count, successFn } = payload;
			context.commit("updateExpected", {
				id,
				count
			});
			const availabilty = context.getters.vacancytypeGet(id);
			context.dispatch("vacancytypeUpdateDebounce", {
				availabilty,
				successFn
			});
		},
		vacancytypeUpdateDebounce: debounce(
			async (
				context,
				{ availabilty, successFn }: VacancyTypeDebounce
			) => {
				const { id } = availabilty;
				await putVacancyType(id, availabilty);
				successFn && successFn();
			},
			500
		),
		async vacancyExportPDF(context, details) {
			try {
				// 1. Call the api
				const pdf = await api.exportListingVacancy(details);
				// place the above variable is used.
				//const date = format(new Date(), "ddMMyyyy_HHmmss");
				//const filename = `vacancy-report-${date}.pdf`;

				//const pdfFile = new Blob([pdf], {
				//	type: "application/pdf"
				//});

				// adding check as not to download file in testing.
				//if ((window as any).Cypress) {
				// Do not attempt to actually download the file in test.
				// Just leave the anchor in there. Ensure your code doesn't
				// automatically remove it either.
				//	return;
				//}

				//FileSaver.saveAs(pdfFile, filename);
			} catch (error) {
				// Just rethrowing error for the moment.
				// will set isFetching to be false here though
				console.log(error);
				throw error;
			}
			// console.log(context);
		},
		async vacancyCompactExportPDF(context, details) {
			try {
				// 1. Call the api
				const pdf = await api.exportListingCompactVacancy(details);
				// place the above variable is used.
				//const date = format(new Date(), "dMMyyyy_HHmmss");
				//const filename = `vacancy-report-compact-${date}.pdf`;

				//const pdfFile = new Blob([pdf], {
				//	type: "application/pdf"
				//});

				//FileSaver.saveAs(pdfFile, filename);
			} catch (error) {
				// Just rethrowing error for the moment.
				// will set isFetching to be false here though
				console.log(error);
				throw error;
			}
		},
		async vacancytypeSetCurrent(context, listingid) {
			await api.vacancytypesSetCurrent(listingid);
			context.commit("vacancytypesUpdatedDate", listingid);
		}
	},
	getters: {
		currentVacancyEditorID: (state) => state.vacancyEditorID,
		demoVacancyGroups: (state) => state.demoVacancyGroups
	}
});
